module.exports = __webpack_public_path__ + "img/45.ffd48dac.jpg";